export default {"src":"/_next/static/media/ic-line-copy.e61e36d3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};